module.exports = __webpack_public_path__ + "img/chofu_buy_on.db98da20.svg";